/* eslint-disable no-param-reassign */
import { bind as mixinBind } from '__core/shared/util/mixin';
import '__sass/app.scss';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import './__extend/javascript';
import './access/.module';
import templateAccess from './access/access.template.html';
import './account/.module';
import templateAccount from './account/account.template.html';
import templateAccounts from './account/accounts.template.html';
import templateAccreditations from './account/accreditations.template.html';
import templatePartners from './account/partnersList.template.html';
import templatePasswordAndSecurity from './account/passwordAndSecurity.template.html';
import templatePersonalization from './account/personalization.template.html';
import templateUpdatesAndReminders from './account/updatesAndReminders.template.html';
import './address/.module';
import './api/.module';
import templateAPI from './api/api.template.html';
import './assetFinance/.module';
import templateAssetFinance from './assetFinance/assetFinance.template.html';
import templateAssetFinanceQuickQuote from './assetFinance/assetFinanceQuickQuote.template.html';
import './attachment/.module';
import './authentication/.module';
import templateAuthenticate from './authentication/authentication.template.html';
import './billing/.module';
import templateBilling from './billing/billing.template.html';
import './call/.module';
import './checklist/.module';
import templateChecklists from './checklist/checklists.template.html';
import './clientaccess/.module';
import './commission/.module';
import templateCommissions from './commission/commissions.template.html';
import './contact/.module';
import templateContactEdit from './contact/contactEdit.template.html';
import templateContacts from './contact/contacts.template.html';
import templateContactView from './contact/contactView.template.html';
import './core/.module';
import './dashboard/.module';
import templateDashboard from './dashboard/dashboard.template.html';
import './diversification/.module';
import templateDiversification from './diversification/diversification.template.html';
import './document/.module';
import templateDocumentEditPDF from './document/documentEditPdf.template.html';
import templateDocuments from './document/documents.template.html';
import './export/.module';
import templateExportData from './export/exportData.template.html';
import './factFind/.module';
import templateFactFind from './factFind/factFind.template.html';
import './field/.module';
import templateFields from './field/fields.template.html';
import './filter/.module';
import './finance/.module';
import './global/.module';
import './home/.module';
import templateHome from './home/home.template.html';
import './homeLoan/.module';
import templateHomeLoan from './homeLoan/homeLoan.template.html';
import templateHomeLoanSwitch from './homeLoan/homeLoanSwitch.template.html';
import './import/.module';
import templateImportData from './import/importData.template.html';
import './integrations/.module';
import templateConnect from './integrations/connect/connect.template.html';
import templateIntegrations from './integrations/integrations.template.html';
import './job/.module';
import templateJobs from './job/jobs.template.html';
import templateJobsProgressView from './job/jobsProgressView.template.html';
import './jobType/.module';
import templateJobTypes from './jobType/jobTypes.template.html';
import './label/.module';
import templateLabels from './label/labels.template.html';
import './lender/.module';
import './lodgement/.module';
import './marketing/.module';
import templateMarketing from './marketing/marketing.template.html';
import './message/.module';
import templateMessages from './message/messages.template.html';
import './navigation/.module';
import './note/.module';
import './organization/.module';
import templateOrganization from './organization/organization.template.html';
import templateOrganizationBranding from './organization/organizationBranding.template.html';
import templateOrganizationClientPortal from './organization/organizationClientPortal.template.html';
import templateOrganizationCommissionLimits from './organization/organizationCommissionLimits.template.html';
import templateOrganizationFeatures from './organization/organizationFeatures.template.html';
import templateOrganizationFinancialPosition from './organization/organizationFinancialPositionBuffers.template.html';
import templateOrganizationGroupsAndBranches from './organization/organizationGroupsAndBranches.template.html';
import templateOrganizationLenderCommissions from './organization/organizationLenderCommissions.template.html';
import templateOrganizationMarketing from './organization/organizationMarketing.template.html';
import templateOrganizationPartnerPortal from './organization/organizationPartnerPortal.template.html';
import templateOrganizationPermissions from './organization/organizationPermissions.template.html';
import templateOrganizationProfessionalLicenses from './organization/organizationProfessionalLicenses.template.html';
import templateOrganizations from './organization/organizations.template.html';
import templateOrganizationSuspended from './organization/organizationSuspended.template.html';
import templateOrganizationSwitch from './organization/organizationSwitch.template.html';
import './pdf/.module';
import './quickTool/.module';
import './report/.module';
import templateReport from './report/report.template.html';
import './riskInsurance/.module';
import templateRiskInsurance from './riskInsurance/riskInsurance.template.html';
import './script/.module';
import templateScripts from './script/scripts.template.html';
import './search/.module';
import './settings/.module';
import templateSettings from './settings/settings.template.html';
import './sms/.module';
import './ticket/.module';
import templateBoard from './ticket/board.template.html';
import templateBoardList from './ticket/boardList.template.html';
import templateFeesAndCharges from './ticket/feesAndCharges.controller.template.html';
import templateEnterprise from './ticket/list.template.html';
import templateProject from './ticket/project.template.html';
import templateTicketEdit from './ticket/ticketEdit.template.html';
import templateTicketView from './ticket/ticketView.template.html';
import './videoconference/.module';
import './workflow/.module';
import templateWorkflowEdit from './workflow/workflowEdit.template.html';
import templateWorkflows from './workflow/workflows.template.html';

export default angular
  .module('st', [
    'st.Core',
    'st.Account',
    'st.Address',
    'st.Billing',
    'st.Attachment',
    'st.AssetFinance',
    'st.Authentication',
    'st.Navigation',
    'st.Call',
    'st.Commission',
    'st.Contact',
    'st.ClientAccess',
    'st.Dashboard',
    'st.Diversification',
    'st.Document',
    'st.Global',
    'st.Home',
    'st.HomeLoan',
    'st.FactFind',
    'st.Field',
    'st.Filter',
    'st.Finance',
    'st.Lender',
    'st.Lodgement',
    'st.Marketing',
    'st.Message',
    'st.Note',
    'st.Job',
    'st.Label',
    'st.JobType',
    'st.Pdf',
    'st.QuickTool',
    'st.Ticket',
    'st.Report',
    'st.RiskInsurance',
    'st.Script',
    'st.Settings',
    'st.Sms',
    'st.Workflow',
    'st.Checklist',
    'st.Organization',
    'st.VideoConference',
    'st.Integrations',
    'st.API',
    'st.Access',
    'st.Import',
    'st.Export'
  ])
  .config(/* @ngInject */ ($stateProvider, $locationProvider, $urlRouterProvider) => {
    $locationProvider.hashPrefix('!').html5Mode(true);
    $stateProvider
      .state('home', { url: '/', template: templateHome, controller: 'homeController' })
      .state('authenticate', {
        url: '/authenticate',
        template: templateAuthenticate,
        controller: 'authenticationController'
      })
      .state('dashboard', {
        url: '/dashboard',
        template: templateDashboard,
        controller: 'dashboardController'
      })
      .state('enterprise', {
        url: '/enterprise',
        template: templateEnterprise,
        controller: 'listController'
      })
      .state('board', {
        url: '/board/:id',
        template: templateBoard,
        controller: 'boardController'
      })
      .state('boardList', {
        url: '/list/:id',
        template: templateBoardList,
        controller: 'boardListController'
      })
      .state('project', {
        url: '/project/:id',
        template: templateProject,
        controller: 'projectController'
      })
      .state('report', {
        url: '/report',
        template: templateReport,
        controller: 'reportController'
      })
      .state('deal', {
        url: '/deal/:id/:dd',
        template: templateTicketView,
        controller: 'ticketViewController'
      })
      .state('dealEdit', {
        url: '/deal/edit/:id/:dd?loanPurpose',
        template: templateTicketEdit,
        controller: 'ticketEditController'
      })
      .state('assetFinance', {
        url: '/deal/asset-finance/:id/:dd',
        template: templateAssetFinance,
        controller: 'assetFinanceController'
      })
      .state('assetFinanceQuickQuote', {
        url: '/deal/asset-finance/quick-quote/:id/:dd',
        template: templateAssetFinanceQuickQuote,
        controller: 'assetFinanceQuickQuoteController'
      })
      .state('homeLoan', {
        url: '/deal/home-loan/:id/:dd',
        template: templateHomeLoan,
        controller: 'homeLoanController'
      })
      .state('feesAndCharges', {
        url: '/deal/:tool/fees-and-charges/:id/:dd',
        template: templateFeesAndCharges,
        controller: 'feesAndChargesController'
      })
      .state('homeLoanSwitch', {
        url: '/deal/home-loan/switch/:id/:dd',
        template: templateHomeLoanSwitch,
        controller: 'homeLoanSwitchController'
      })
      .state('riskInsurance', {
        url: '/deal/risk-insurance/:id/:dd',
        template: templateRiskInsurance,
        controller: 'riskInsuranceController'
      })
      .state('factFind', {
        url: '/fact-find/:id/:dd?clientId',
        template: templateFactFind,
        controller: 'factFindController'
      })
      .state('tasks', {
        url: '/tasks?jobId',
        template: templateJobs,
        controller: 'jobsController'
      })
      .state('progress', {
        url: '/progress?jobId',
        template: templateJobsProgressView,
        controller: 'jobsProgressViewController'
      })
      .state('contacts', {
        url: '/contacts',
        template: templateContacts,
        controller: 'contactsController'
      })
      .state('contactEdit', {
        url: '/contact/edit/:type/:id',
        template: templateContactEdit,
        controller: 'contactEditController'
      })
      .state('contactView', {
        url: '/contact/view/:type/:id',
        template: templateContactView,
        controller: 'contactViewController'
      })
      .state('marketing', {
        url: '/marketing',
        template: templateMarketing,
        controller: 'marketingController'
      })
      .state('settings', {
        url: '/settings',
        template: templateSettings,
        controller: 'settingsController'
      })
      .state('settings.my-account', {
        url: '/my-account',
        template: templateAccount,
        controller: 'accountController'
      })
      .state('settings.my-accreditations', {
        url: '/my-accreditations',
        template: templateAccreditations,
        controller: 'accreditationsController'
      })
      .state('settings.my-personalization', {
        url: '/my-personalization',
        template: templatePersonalization,
        controller: 'personalizationController'
      })
      .state('settings.updates-and-reminders', {
        url: '/updates-and-reminders',
        template: templateUpdatesAndReminders,
        controller: 'updatesAndRemindersController'
      })
      .state('settings.password-and-security', {
        url: '/password-and-security',
        template: templatePasswordAndSecurity,
        controller: 'passwordAndSecurityController'
      })
      .state('settings.organization', {
        url: '/organization',
        template: templateOrganization,
        controller: 'organizationController'
      })
      .state('settings.users', {
        url: '/users',
        template: templateAccounts,
        controller: 'accountsController'
      })
      .state('settings.partners', {
        url: '/partners',
        template: templatePartners,
        controller: 'partnersController'
      })
      .state('settings.connect', {
        url: '/connect',
        template: templateConnect,
        controller: 'connectController'
      })
      .state('settings.marketing', {
        url: '/marketing',
        template: templateOrganizationMarketing,
        controller: 'organizationMarketingController'
      })
      .state('settings.diversification', {
        url: '/diversification',
        template: templateDiversification,
        controller: 'diversificationController'
      })
      .state('settings.client-portal', {
        url: '/client-portal',
        template: templateOrganizationClientPortal,
        controller: 'organizationClientPortalController'
      })
      .state('settings.partner-portal', {
        url: '/partner-portal',
        template: templateOrganizationPartnerPortal,
        controller: 'organizationPartnerPortalController'
      })
      .state('settings.permissions', {
        url: '/permissions',
        template: templateOrganizationPermissions,
        controller: 'organizationPermissionsController'
      })
      .state('settings.financial-position-buffers', {
        url: '/financial-position-buffers',
        template: templateOrganizationFinancialPosition,
        controller: 'organizationFinancialPositionBuffersController'
      })
      .state('settings.my-organizations', {
        url: '/my-organizations',
        template: templateOrganizations,
        controller: 'organizationsController'
      })
      .state('settings.plan-and-billing', {
        url: '/plan-and-billing',
        template: templateBilling,
        controller: 'billingController'
      })
      .state('settings.labels', {
        url: '/labels',
        template: templateLabels,
        controller: 'labelsController'
      })
      .state('settings.checklists', {
        url: '/checklists',
        template: templateChecklists,
        controller: 'checklistsController'
      })
      .state('settings.tasks', {
        url: '/tasks',
        template: templateJobTypes,
        controller: 'jobTypesController'
      })
      .state('settings.notifications', {
        url: '/notifications',
        template: templateMessages,
        controller: 'messagesController'
      })
      .state('settings.documents', {
        url: '/documents',
        template: templateDocuments,
        controller: 'documentsController'
      })
      .state('settings.documents-fill-pdf', {
        url: '/documents/fill-pdf/:id',
        template: templateDocumentEditPDF,
        controller: 'documentEditPdfController'
      })
      .state('settings.scripts', {
        url: '/scripts',
        template: templateScripts,
        controller: 'scriptsController'
      })
      .state('settings.fields', {
        url: '/fields',
        template: templateFields,
        controller: 'fieldsController'
      })
      .state('settings.workflows', {
        url: '/workflows',
        template: templateWorkflows,
        controller: 'workflowsController'
      })
      .state('settings.workflow', {
        url: '/workflow/:id',
        template: templateWorkflowEdit,
        controller: 'workflowEditController'
      })
      .state('settings.access', {
        url: '/access',
        template: templateAccess,
        controller: 'accessController'
      })
      .state('settings.integrations', {
        url: '/integrations?code&state&type&scope',
        template: templateIntegrations,
        controller: 'integrationsController'
      })
      .state('settings.api', {
        url: '/api',
        template: templateAPI,
        controller: 'apiController'
      })
      .state('settings.import-data', {
        url: '/import-data',
        template: templateImportData,
        controller: 'importDataController'
      })
      .state('settings.export-data', {
        url: '/export-data',
        template: templateExportData,
        controller: 'exportDataController'
      })
      .state('settings.commission-groups', {
        url: '/commission-groups',
        template: templateCommissions,
        controller: 'commissionsController'
      })
      .state('settings.commission-limits', {
        url: '/commission-limits',
        template: templateOrganizationCommissionLimits,
        controller: 'organizationCommissionLimitsController'
      })
      .state('settings.lender-commissions', {
        url: '/lender-commissions',
        template: templateOrganizationLenderCommissions,
        controller: 'organizationLenderCommissionsController'
      })
      .state('settings.groups-and-branches', {
        url: '/groups-and-branches?code&state',
        template: templateOrganizationGroupsAndBranches,
        controller: 'organizationGroupsAndBranchesController'
      })
      .state('settings.branding', {
        url: '/branding',
        template: templateOrganizationBranding,
        controller: 'organizationBrandingController'
      })
      .state('settings.features', {
        url: '/features',
        template: templateOrganizationFeatures,
        controller: 'organizationFeaturesController'
      })
      .state('settings.professional-licenses', {
        url: '/professional-licenses',
        template: templateOrganizationProfessionalLicenses,
        controller: 'organizationProfessionalLicensesController'
      })
      .state('organizationSuspended', {
        url: '/organization-suspended',
        template: templateOrganizationSuspended,
        controller: 'organizationSuspendedController'
      })
      .state('organizationSwitch', {
        url: '/organization-switch',
        template: templateOrganizationSwitch,
        controller: 'organizationSwitchController'
      });
    $urlRouterProvider.otherwise('/authenticate');
  })
  .config(/* @ngInject */ ($compileProvider) => {
    $compileProvider.debugInfoEnabled(true);
    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|file|skype):/);
  })
  .config(/* @ngInject */ (loggerProvider) => {
    loggerProvider.setEnabled(false);
  })
  .config(/* @ngInject */ ($httpProvider) => {
    $httpProvider.useApplyAsync(true);
    if (!$httpProvider.defaults.headers.get) {
      $httpProvider.defaults.headers.common = {};
    }
    $httpProvider.defaults.headers.common.Pragma = 'no-cache';
    $httpProvider.defaults.headers.common['Cache-Control'] = 'no-cache';
    $httpProvider.defaults.headers.common['If-Modified-Since'] = '0';
  })
  .config(/* @ngInject */ ($httpProvider, jwtOptionsProvider) => {
    jwtOptionsProvider.config({
      unauthenticatedRedirectPath: '/authenticate',
      whiteListedDomains: [
        'https://scs-api.corelogic.asia',
        'http://api.pricefinder.com.au/',
        'https://content-mgr-api.corelogic.asia',
        'https://public-salestrekker.s3.ap-southeast-2.amazonaws.com/'
      ],
      tokenGetter: [
        'options',
        'authenticationService',
        (options, authenticationService) =>
          _.startsWith(options.url, '/api/') ? authenticationService.tokenGet() : null
      ]
    });
    $httpProvider.interceptors.push('jwtInterceptor');
  })
  .config(/* @ngInject */ (IdleProvider) => {
    IdleProvider.idle(7140);
    IdleProvider.timeout(60);
  })
  .config(/* @ngInject */ (webpageProvider) => {
    webpageProvider.pageTitleDefault('loading ...', true);
  })
  .config(/* @ngInject */ ($qProvider) => {
    $qProvider.errorOnUnhandledRejections(false);
  })
  .config(/* @ngInject */ ($mdIconProvider) => {
    $mdIconProvider.iconSet('social', 'assets/images/material-icons/social.svg', 48);
  })
  .config(/* @ngInject */ (cfpLoadingBarProvider) => {
    cfpLoadingBarProvider.includeSpinner = false;
  })
  .run(/* @ngInject */ ($rootScope, $mdDateLocale) => {
    $mdDateLocale.firstDayOfWeek = 1;
    $mdDateLocale.parseDate = (dateString) => {
      const dateFormat = $rootScope.CurrentDateFormatPrimary()
        ? $rootScope.CurrentDateFormatPrimary()
        : 'LL';
      const m = moment(dateString, dateFormat, true);
      return m.isValid() ? m.toDate() : new Date(NaN);
    };
    $mdDateLocale.formatDate = (date) => {
      const dateFormat = $rootScope.CurrentDateFormatPrimary()
        ? $rootScope.CurrentDateFormatPrimary()
        : 'LL';
      return _.isDate(date) ? moment(date).format(dateFormat) : '';
    };
    $mdDateLocale.monthHeaderFormatter = (date) =>
      `${moment(date).format('MMM')} ${moment(date).format('YYYY')}`;
  })
  .run(
    /* @ngInject */
    (
      $window,
      $location,
      $rootScope,
      authenticationService,
      eventService,
      navigationService
    ) => {
      window.Intercom('boot', { app_id: 'ratt5ci6' });
      authenticationService.credentialsValidate();
      $rootScope.$on('$stateChangeStart', ($event, toState) => {
        navigationService.goTo($event, toState);
      });
      $rootScope.$on(
        '$stateChangeSuccess',
        (event, toState, toParams, fromState, fromParams) => {
          navigationService.persist(toState, toParams, fromState, fromParams);
          $window.Intercom('update');
          ga('send', 'pageview', $location.path());
        }
      );
      eventService.onCredentialsExpiring(() => {
        if (authenticationService.isAuthenticated()) {
          navigationService.organizationChange({
            idOrganization: $rootScope.CurrentOrganization.id
          });
        }
      });
      $rootScope.online = navigator.onLine;
      $window.addEventListener(
        'offline',
        () => {
          $rootScope.$apply(() => {
            $rootScope.online = false;
            eventService.toggleConnection();
          });
        },
        false
      );
      $window.addEventListener(
        'online',
        () => {
          $rootScope.$apply(() => {
            $rootScope.online = true;
            eventService.toggleConnection();
          });
        },
        false
      );
    }
  )
  .run(/* @ngInject */ ($rootScope, $mdMedia, dateTimeService, INSTANCE) => {
    mixinBind(true, 'dd/MM/yyyy', 'en-AU');

    $rootScope.hasBrokerToolsEnabled = () => {
      const brokerOrganizations = [
        '46699f0c-6a9a-4c2a-81b6-f51ef355eb73', // EVEN
        '9e44bfdb-e877-4ce3-814e-ab452c406094', // ST PROJECT
        '072cb033-93e0-4872-a5c7-f72cec0a1fe9', // DEMO&CO
        'ee9ca761-9bf4-49d5-963b-0b5f27bfd1a7', // YBR
        'cc26c628-66c0-4842-a50e-0f13f2d258d6', // ASTUTE
        'af98c8b8-13b0-4138-b22a-ff0dcca72541', // PREMIUM BROKER
        '8723ae48-5c21-4994-88c7-16176261edee', // ACCRUE EQUITY
        '18a8db96-2617-44fb-b03b-ee073e4486fc', // ASTUTE FINANCIAL - MELBOURNE
        'b24e32b6-4e39-42b4-996a-bc032f6107c3', // MYBROKERONLINE
        '7dc8f207-459f-4fc9-ba69-b43fe79ed56c', // ELEPHANT
        '39031303-fda5-49a7-befe-575eab301ff6', // TRADIES FINANCE
        'ed586800-7847-4199-b24f-61f4cdc0ff6c', // IRENE ONG
        '6884ca02-aee5-42d9-b93d-b5f9dfeccedc', // FIRSTPOINT MORTGAGE BROKERS
        '47672183-4467-426b-ad65-4927f227d1e2', // FIRSTPOINT MORTGAGE BROKERS (GREG)
        '3cf00563-eda5-44ac-a8df-ba4300a05e89', // STANDARD LENDING
        'cefb5f67-c9c7-4276-833b-fb3095dc939e', // ASTUTE DEE WHY
        '5ded0135-f9a8-4f19-9ddd-458169ff1d15', // RAREBREED FINANCE PTY LTD
        '05f6dc3c-71d2-4788-84a9-c64cc2d3bf43', // ASTUTE EAST BRISBANE
        'b54c4993-4cd4-4225-9e6a-2791771e3883', // ASTUTE NORTH QUEENSLAND
        'b266d0d7-d56d-4b39-b1b5-b1a77a39ace0', // WINNING HOMELOANS
        '487aeb61-66f7-4c04-b953-0570b79a772c', // SCOTT JUDA
        'cd6ed998-1107-42cf-9771-5bb99f186a96', // ECLECTIC FINANCIAL
        '85438444-6b2f-4b52-9a0d-46a6dab96ce3', // EVENGROUND
        'f80b0318-a9ea-4135-b638-48339d90ad88', // XSOURCE TRAINING
        'e6e376ce-2780-4926-ba46-e8ad64db845d', // ADAM RUNCIMAN
        'c2864950-e61a-4351-846f-2a7f5af5008b', // JOHN HAMMERTON
        'a19aca2b-5b1d-4fcf-ba23-b3f0ca9614b3', // CAMBRIDGE FINANCIAL SOLUTIONS
        '064a6a58-3a00-4e29-be87-32ae2469f2d6', // SPECIALIST FINANCE GROUP
        '312b2e76-0ecd-4861-91f2-611249c25671', // MORTGAGE CONNEX
        '0b2d1fe0-4854-4e40-a19f-db1ecc7a8de1', // REAL ESTATE HOME LOANS
        'a8d125d5-00de-4087-83cd-296f7dba8b0c', // MINTWELL CAPITAL
        '112e7545-cc67-499d-aa11-a59889251990', // GENERATION MORTGAGE
        '09b36e29-7179-4fc6-817d-7233b38a40c1', // XSOURCE PARABROKER
        'd41dc05f-12e3-4c48-8066-c8297d8f8e69', // BRABO GROUP
        'ff46c381-4889-491d-bfe2-0e51cb31273d', // CAPITAL UNITED
        'cc177ac5-4740-4d7a-9f24-8e8f43ba34b5', // GROW CAPITAL
        '18dd426b-270b-4613-ab39-ad6d92418cb4', // MONEY SIMPLICITY
        '51ce682b-9b60-4f56-a3d7-b29f654d98d6', // RED ROCK GROUP
        'c2864950-e61a-4351-846f-2a7f5af5008b', // CSC
        '4129311d-0ffd-48a7-b65b-63b28cc44bdb', // URBAN MONEY
        '8b99921d-18f4-47bb-98cf-0f2ba62adf76', // HAMLEN HOMES
        'c676145f-587e-4a24-aebe-3c888cb936ba', // LOANER
        'ee9ca761-9bf4-49d5-963b-0b5f27bfd1a7', // VOWNET
        '8a6fe748-3a01-40c5-a5cc-4554ed6f57cf', // NMB
        '61a1af26-56a8-46d6-a6a0-9a74c68dc42c', // SALESTREKKER TRG
        'a8677ec3-e3ec-42f2-9cf7-b9073ac0feae', // SIERRA CAPITAL (2nd org)
        '10925b6f-fc5f-4e21-a8bf-ae8242fc61a3', // LEITH
        'd0d5fdfd-daf5-4618-9211-057c12413009', // WA VOW TEAM
        'b1de0a38-b391-4088-b0fb-958752c97663', // INDIGO FINANCE
        'c8a83c3b-1d02-4981-951a-bb0ce73b8a10', // QUEENSLAND VOW TEAM
        '2834114c-94bc-45c0-a811-3624c8ef93ba', // MARKET STREET FINANCE
        'c39b7b1b-8445-48ec-947e-8fea4679977e', // SALESKEY
        'e440dc43-d4c6-407f-9a3b-b03fda43587e', // CAPITAL FUSION
        '037349d1-9162-4ab4-b81b-753bff07f861', // AXISWEALTH
        'e0db56fb-a604-4469-a405-8f982455e8bb', // SYDNEY MORTGAGE EXPERTS
        '20a4ac38-d787-476d-88c6-20adfbf05e78', // FUNDINGPRO
        'a6530e75-f5a3-49ce-9bde-aee559015a53', // ONLINE HOME LOANS
        '639c7dd4-42ee-4d28-b5a9-0ebdf1f8bdc2', // AZTEC FINANCIAL
        '51ce682b-9b60-4f56-a3d7-b29f654d98d6', // RED ROCK GROUP
        '9cac546a-b198-4efc-b19f-0ee48ec768fe', // INSYNERGY
        '06589814-59ff-4de5-ae63-1423317f9cfa', // WEST CORP FINANCE
        'a0d3c359-14bb-4e5f-be95-31e552e236f8', // HOUSE HOME LOANS
        '12570779-8a87-4da8-81ee-6217532696e8', // FINANCE FERRET
        '39031303-fda5-49a7-befe-575eab301ff6', // TRADIES FINANCE
        '85ca743e-6cae-4787-bc7d-aee9775d0c9e', // NEW LIFE FUNDING
        '52904c91-d73c-40f2-a8ca-c868b32dda95', // IRENE PLAVINA
        'fb2806c6-bdf8-4405-a698-779df1b68249', // MORTGAGE EFFECT
        '2b52dc09-8672-4c41-9861-92898e72975b', // LENDI
        '465ab637-f794-454b-ad4b-75fbd0ed8a17', // REDUCE HOME LOANS
        '33c4b24d-24f5-47b7-9598-f8be10b33b20', // SAIPH FINANCE
        '98a92af4-0895-4573-895e-2840b55b7286', // FINANCE PATH
        '459a0808-9b0e-4c6b-956f-74593ee8193a' // API TEST
      ];
      return (
        !$rootScope.CurrentOrganization.isAnyBrokerExpired() ||
        brokerOrganizations.indexOf($rootScope.CurrentOrganization.id) > -1
      );
    };
    $rootScope.isAfg = () => INSTANCE.identification === 'AFG';
    $rootScope.isChf = () => INSTANCE.identification === 'CHF';
    $rootScope.isCps = () => INSTANCE.identification === 'CPS';
    $rootScope.isDev = () => INSTANCE.identification === 'DEV';
    $rootScope.isGem = () => INSTANCE.identification === 'GEM';
    $rootScope.isGnz = () => INSTANCE.identification === 'GNZ';
    $rootScope.isIot = () => INSTANCE.identification === 'IOT';
    $rootScope.isLnq = () => INSTANCE.identification === 'LNQ';
    $rootScope.isMag = () => INSTANCE.identification === 'MAG';
    $rootScope.isNlg = () => INSTANCE.identification === 'NLG';
    $rootScope.isPpc = () => INSTANCE.identification === 'PPC';
    $rootScope.isPtf = () => INSTANCE.identification === 'PTF';
    $rootScope.isRef = () => INSTANCE.identification === 'REF';
    $rootScope.isRmy = () => INSTANCE.identification === 'RMY';
    $rootScope.isSfg = () => INSTANCE.identification === 'SFG';
    $rootScope.isShf = () => INSTANCE.identification === 'SHF';
    $rootScope.isVow = () => INSTANCE.identification === 'VOW';
    $rootScope.isYnt = () => INSTANCE.identification === 'YNT';
    $rootScope.isApp = () => INSTANCE.identification === 'SALESTREKKER';
    $rootScope.isAstuteOrg = () => {
      const brokerOrganizations = [
        'cc26c628-66c0-4842-a50e-0f13f2d258d6', // ASTUTE
        '18a8db96-2617-44fb-b03b-ee073e4486fc', // ASTUTE FINANCIAL - MELBOURNE
        'cefb5f67-c9c7-4276-833b-fb3095dc939e', // ASTUTE DEE WHY
        '05f6dc3c-71d2-4788-84a9-c64cc2d3bf43', // ASTUTE EAST BRISBANE
        'b54c4993-4cd4-4225-9e6a-2791771e3883', // ASTUTE NORTH QUEENSLAND
        '46699f0c-6a9a-4c2a-81b6-f51ef355eb73' // EVEN
      ];
      return (
        brokerOrganizations.indexOf($rootScope.CurrentOrganization.id) > -1 ||
        INSTANCE.identification === 'GEM'
      );
    };
    $rootScope.canSeeAccountsAsPartnersOption = () =>
      $rootScope.isAstuteOrg() ||
      $rootScope.isDev() ||
      $rootScope.isNlg() ||
      $rootScope.isPtf() ||
      $rootScope.isChf() ||
      $rootScope.isLnq();
    $rootScope.isGNZOrg = () => INSTANCE.identification === 'GNZ';
    $rootScope.hasCommissionsPostingEnabled = () => {
      const brokerOrganizations = [
        '46699f0c-6a9a-4c2a-81b6-f51ef355eb73', // EVEN
        'b39197d3-5a04-439c-8a2b-f3adde80200b', // LEARN GEM (NZ)
        'dd5752f9-97d3-4bc8-89de-134fb750f8f6', // SALESTREKKER DEMO
        '1ca41683-b2ce-400f-b2b3-b838dac07f1c' // LEARN IOUTSOURCE
      ];
      return (
        brokerOrganizations.indexOf($rootScope.CurrentOrganization.id) > -1 ||
        $rootScope.isAstuteOrg() ||
        $rootScope.isDev() ||
        $rootScope.isGem() ||
        $rootScope.isGnz() ||
        $rootScope.isIot()
      );
    };
    $rootScope.canSeeNeedsAnalysis = () =>
      $rootScope.isAstuteOrg() || INSTANCE.canSeeNeedsAnalysis;
    $rootScope.canSeeAssetFinanceTools = () => !$rootScope.isGnz();

    $rootScope.canSeeRiskInsuranceTools = () => $rootScope.isDev() || $rootScope.isGnz();

    $rootScope.canSeePdfService = () =>
      $rootScope.CurrentOrganization &&
      $rootScope.CurrentOrganization.organization &&
      $rootScope.CurrentOrganization.organization.location &&
      $rootScope.CurrentOrganization.organization.location.cca2 &&
      $rootScope.CurrentOrganization.organization.location.cca2 === 'NZ';

    $rootScope.canSeeInsuranceTools = () =>
      $rootScope.CurrentOrganization.id === '01255cee-6d2d-4747-9665-acbc3302bc45';

    $rootScope.hasApplyOnlineEnabled = () => {
      const brokerOrganizations = [
        '46699f0c-6a9a-4c2a-81b6-f51ef355eb73', // EVEN
        '072cb033-93e0-4872-a5c7-f72cec0a1fe9', // DEMO&CO
        'af98c8b8-13b0-4138-b22a-ff0dcca72541', // PREMIUM BROKER
        'ee9ca761-9bf4-49d5-963b-0b5f27bfd1a7', // VOWNET
        '10925b6f-fc5f-4e21-a8bf-ae8242fc61a3', // LEITH
        '459a0808-9b0e-4c6b-956f-74593ee8193a', // API TEST
        '99d6f5ff-f390-4918-87f8-2f600d477a45', // WHITE STAR
        '7c3ee22c-00b4-4641-bab1-e8d30465091f', // SHROOGAL
        'dd5752f9-97d3-4bc8-89de-134fb750f8f6', // SALESTREKKER DEMO
        '1ca41683-b2ce-400f-b2b3-b838dac07f1c', // LEARN IOUTSOURCE
        '8a2add1a-fe80-4049-8717-b79c34e0caa2', // YELLOW BRICK ROAD CAMPBELLTOWN
        '8b355ede-d168-4e0c-9498-aa8f14b020d1', // YELLOW BRICK ROAD PARRAMATTA
        '78ca9944-bd5a-46d2-8b39-5f8350b20d5f', // YELLOW BRICK ROAD BRIGHTON
        '4e1466db-c4df-4cc7-a72e-7f2b6c7cdeec', // YELLOW BRICK ROAD NAMBOUR

        'ac4d7f34-a9a4-482c-a5bf-a190425b7e14', // FINANCE AND MORTGAGE SOLUTIONS
        '868a13d6-6a84-423b-bd49-243d3850b48a', // FINANCE AND MORTGAGE SOLUTIONS - BAULKHAM HILLS
        '81d649a7-b2bf-4b74-b121-358b6d4936ec', // FINANCE AND MORTGAGE SOLUTIONS - PARAMATTA
        'ff5e236c-c2a8-41f3-b346-6d2935c3d072', // FINANCE AND MORTGAGE SOLUTIONS CANBERRA
        '78d25ce1-11bd-47e3-b086-07a88f59e012', // FINANCE AND MORTGAGE SOLUTIONS BEST CHOICE LOANS
        '1f0995cd-66eb-4c86-8942-9f0f29917269', // FMS TESTING
        'f4c6f1e7-2cb2-40ca-9887-50f9d0d08de7', // GROWEALTH
        '010ea115-cb7d-45d8-8e7a-98f7f9e48b4f', // HAMOOD RAHMAN
        'd0166bd9-0597-450a-99b7-de6be8c48a38', // JR FINANCIAL SOLUTIONS
        '214143c8-ee37-41fa-a6d6-86a88a06f3c9', // JUST RIGHT LOANS
        '0553bc50-a983-4622-b221-3eaa18d75eef', // MOHISH MUKHI
        '9c4a5ece-f9c8-4b15-b765-ab06a0719e0a', // MYAAR BUSINESS GROUP
        '69c68e01-ebcc-42a8-a11d-ed372874a49b', // SUBRAMANIAM SIVASHANKAR
        '91531bc1-2dc2-4c2e-9a42-83c3de213068', // MANSI SAXENA
        'ac2e6cfb-8ee7-4458-b2ad-f7f5f70cdc3a', // YASHICA FINANCIAL SERVICES
        'f2134191-bed0-40ef-b43d-23cf9464d4a2', // ROHIT SACHDEVA
        'bb3fa3e7-ee2b-4e4e-9532-a775a03e8a35' // MIND AVENUE
      ];
      return (
        brokerOrganizations.indexOf($rootScope.CurrentOrganization.id) > -1 ||
        brokerOrganizations.indexOf($rootScope.CurrentOrganization.idParent) > -1 ||
        INSTANCE.isApplyOnlineEnabled
      );
    };
    $rootScope.isCampaignMonitorEnabled = () => INSTANCE.isCampaignMonitorEnableds;
    $rootScope.hasDriveOnlineEnabled = () => true;
    $rootScope.hasLoanWorksEnabled = () => $rootScope.isLearnOrganization();
    $rootScope.hasLatitudeEnabled = () => INSTANCE.isLatitudeEnabled;
    $rootScope.hasSimpologyEnabled = () => INSTANCE.isSimpologyEnabled;
    $rootScope.isIOutsourceOrg = () => {
      const brokerOrganizations = [
        'dd5752f9-97d3-4bc8-89de-134fb750f8f6' // SALESTREKKER DEMO
      ];
      return (
        brokerOrganizations.indexOf($rootScope.CurrentOrganization.id) > -1 ||
        INSTANCE.identification === 'IOT'
      );
    };
    $rootScope.hasVeroEnabled = () => {
      const brokerOrganizations = [
        '46699f0c-6a9a-4c2a-81b6-f51ef355eb73' // EVEN
      ];
      return (
        brokerOrganizations.indexOf($rootScope.CurrentOrganization.id) > -1 ||
        INSTANCE.isVeroEnabled
      );
    };
    $rootScope.hasCreditFixSolutionEnabled = () => INSTANCE.isCreditFixSolutionEnabled;
    $rootScope.hasHoneyEnabled = () => INSTANCE.isHoneyEnabled;
    $rootScope.hasSettleEasyEnabled = () => INSTANCE.isSettleEasyEnabled;
    $rootScope.hasAllianzEnabled = () => INSTANCE.isAllianzEnabled;
    $rootScope.hasAliEnabled = () => INSTANCE.isAliEnabled;
    $rootScope.isMovingHubEnabled = () => INSTANCE.isMovingHubEnabled;
    $rootScope.hasFlexEnabled = () => {
      const brokerOrganizations = [
        '46699f0c-6a9a-4c2a-81b6-f51ef355eb73' // EVEN
      ];
      return (
        brokerOrganizations.indexOf($rootScope.CurrentOrganization.id) > -1 ||
        INSTANCE.isFlexEnabled
      );
    };
    $rootScope.hasPepperResolveEnabled = () => {
      const brokerOrganizations = [
        'dd5752f9-97d3-4bc8-89de-134fb750f8f6', // SALESTREKKER DEMO,
        '39031303-fda5-49a7-befe-575eab301ff6'
      ];
      return (
        (brokerOrganizations.indexOf($rootScope.CurrentOrganization.id) > -1 &&
          INSTANCE.name === 'Salestrekker') ||
        INSTANCE.isPepperResolveEnabled
      );
    };

    $rootScope.hasPepperAssetFinanceEnabled = () => true;

    $rootScope.hasMacquarieAssetFinanceEnabled = () => true;

    $rootScope.isNmb = () => {
      const brokerOrganizations = [
        '10295588-fb45-4710-9949-c5f9c76becca', // CHAMBERLAIN & CO
        '88486ee3-39c0-4da5-a09b-4090a905519a', // AUSFINANCE
        '6884ca02-aee5-42d9-b93d-b5f9dfeccedc', // FIRST POINT MORTGAGE BROKERS
        '47672183-4467-426b-ad65-4927f227d1e2', // FIRSTPOINT MORTGAGE BROKERS (GREG)
        '9bc55f1d-894f-4cb6-a0f4-72296b337156', // ALPHALOAN MORTGAGE GROUP
        '02b97c99-3bb3-4aab-8048-09535deb10f4', // MMF FINANCE AND CONSULTING
        '4f23d2ef-a1c3-46cd-a1bd-773318f47bb3', // NEW BRANCH UNDER GROUP NO2 (DEV)
        '3f2e7df8-7910-4a85-8d1c-fa62e7f09b28', // FINANCE RIGHT PTY LTD
        '8c6b39be-2c56-4e95-a569-33f5b5c64ce7', // CENTRAL MORTGAGE BROKER PTY LTD
        '7880efb3-a3b1-4aa8-89b1-e58a3949fb19', // TIFFEN & CO
        '97bf30df-5910-407b-9dfb-7b6a322a75dd', // Finance Broker Melbourne
        'cc8f9607-d142-49a5-934e-01bf47180bc2', // APP: Eastbourne Capital
        '352dd988-f4f7-4ea0-840f-af1e7bc8be4c', // APP: Yarra Financial Broker
        'f77dcea4-dff1-4a08-bd72-909bd2c7ae95', // PTF: My Mortgage Broker
        'b0be9184-553e-4a9f-82fd-a24a679b3fc4', // APP: Dollar Finance Brokers
        'e2879a31-6156-48c4-a5a7-d3d85ba91806', // APP: Pebble Finance
        '5ea8590d-6c06-4c26-9b7d-bb03e653c280', // APP: Dobbyn and Carafa Finance
        'bec4c705-4d2c-4725-8996-28a32a293098', // APP: Orchid Financial Services
        '439023cb-cf1a-4345-baef-d8aec4eb87f2', // APP: The Avenue Home Loans
        'fe81e87d-088e-425e-8106-5f673df681ca', // APP: Access Financial
        '16963dd6-2b26-40f3-956b-e87d19f72c34', // APP: Certitude Finance Group
        '5823ade2-8a94-4b43-b4b7-ba4f4d700e52', // APP: Loans on the Run
        'ebd02674-7fe3-4324-9e86-d2b38999f92d', // APP: PBI Mortgages Pty Ltd
        '7c389531-927d-44f4-af63-6e02e7f10bc3', // APP: JDH Financial Group
        '9a72fb06-2797-4e93-ba95-102d4cda2681', // APP: Maple Property Group
        'b3799d42-8bfc-4c52-943c-5c5b14caa605', // APP: Vin Capital Pty. Ltd.
        '7bc4035f-b937-4a00-9ad4-781f0aadf4fe', // APP: Next Generation Mortgages
        '31729c65-21cd-4c6b-a44c-06633d95c2d0', // APP: Real Simple Homeloans
        '1eb5f717-5c65-4efd-b452-f7134b564e45', // APP: Lagos Financial
        '0debd83b-25f5-443d-afa2-e470ec69c08b', // APP: Fintcap Pty Ltd
        '098d6aca-100b-40d5-b850-55d1c7680b64', // APP: Mondo Mortgages
        'fbe3ec3e-05b4-4a47-9991-66358a36dad1', // APP: Rob Emmett
        '2036a1e0-b803-4cfe-9a39-5d5323db1744', // APP: Prowse Financial Group
        '9347c0b1-0ffc-4914-863e-f62a9513fa14', // APP: Wicks Brokering Services
        'f5c6af81-c190-4ab0-895d-e85e2ad43d4e', // PTF: The Regional Finance Hub
        '9b7f107b-830c-4e8c-8e0a-18400059240d', // APP: AIM FS Pty Ltd
        'bf5b012f-4e84-44be-9d82-78399df3f31f', // APP: Auspak Home Loans
        '731c6170-03d5-4a74-9633-3b93651d3eac', // APP: Elizabeth Pregarz
        '246cec8f-3b9a-4dbd-825d-ac3bd8e11b52', // APP: Babo Finance
        '2152ce3c-3080-4fdf-8f30-7283057e6aa2', // APP: Woolim FInance
        '81d9d25c-eb18-4cd4-8c2f-c6d90d1cf0d4', // APP: Ourloan Finance Brokers
        'cda40660-c16a-422d-9513-d1689f1a540c', // APP: Taxxed Accounting Pty Ltd
        '6b4b43a4-7587-49c2-806e-6157a0d51486', // APP: Peninsula Lending Co
        '092ff869-af82-4bd9-9a2e-5da1323de6ef', // APP: Welcome Home Mortgages Pty Ltd
        'ee23f561-068c-4784-b126-279f36476a85', // APP: Alliance Mortgage Group
        'bcc7bbdf-d1ac-4a30-8e3c-2d8cdb925f57', // APP: uBroker Finance Group
        '5bd96d29-126b-4856-8307-f8109721b232', // APP: Wood & Weiss
        '324b04bf-023f-44a9-ad9e-fbc7437973d9', // APP: # Omega Finance Enterprise
        'c82149c5-ecac-4760-ad03-9c74606d8c23', // APP: Loanworx Group Pty Ltd ATF Loanworx Group Trust
        '86d757bb-0561-47cc-aafd-3028a03b49e3', // APP: Pebble Finance
        'f98a1f59-49c1-4a8d-aacb-e9d332668e5f', // APP: Learn Pebble
        'af87ade1-32dc-4453-8ecf-b1bb9ae9e2e4', // APP: DC Finance
        '92ddac5a-b21a-45fb-8f42-bb9fbec41f94', // APP: Lendbright
        '36f228c4-905d-4194-b35c-7df5adaff761', // APP: Loansvilla
        '6877bf17-b5e5-450d-9749-896830c474cf', // APP: National Mortgage Brokers (nMB)
        '59036000-7ae4-43c1-a4ad-e9b21550c9ab', // APP: New Brokers Pty Ltd ATF New Brokers Unit Trust
        '959e4a2f-4aac-406d-808f-0366fe874c8b', // APP: Pebble Finance Pty Ltd ATF Pebble Finance Unit Trust
        'eac0f6bf-37c3-47e3-b5cc-4efe0aa77b77', // APP: Core Mortgage Brokers
        'a06b185a-af15-48f1-8367-8d213fcd626c', // APP: OZO Finance
        'bbede25a-89e0-4036-857f-e5af71fcf50e', // APP: Financial $olutions Pty Ltd
        '3ee5e722-2f79-41bf-b22c-c67a04915658', // APP: Mario Navarro
        '800bc4f6-8850-4086-a189-2f75919cf9ac', // APP: Summit Finance Group
        '6a764597-eb30-4a99-9899-ec245d1fdaef', // APP: Premium Lending Group
        'b5a18d41-d5f4-4387-9a6b-44f8f53d93f3', // APP: Kula Financial Services
        '647d647c-049a-4dbc-b079-f7ffcc9b5798', // APP: MKD Finance Pty Ltd
        '381453df-9312-4bc6-87aa-10f8b70cb22c', // APP: Domain Financial
        '066ca72c-e66c-4ae6-9d7b-f4d7e1768356', // APP: Tanz Finance
        '23306ec8-7bdf-4cc9-91f3-f87c7e12ad84', // APP: Elite Finance Pty Ltd
        '7b19bb6d-424c-46f9-9fe5-f120a95657f9', // PTF: Treehouse Finance
        '1420a997-cd9e-4d4f-aa32-7963e59a5397', // PTF: Blue Horizon Finance
        '82062a6b-e80f-425b-9f7c-e3e4eb15d73a', // APP: Actum Advisory Pty Ltd
        '61cf86e5-c8f9-4705-9cda-187dd2d6d264', // APP: Eureka Lending Group
        '575386e5-cc12-45e3-a301-0b2ef1e97128', // APP: Quantaco Capital
        '8a5c94a7-7ea6-4874-b128-8b9d95546e4e' // APP: Loans On The Run
      ];
      return brokerOrganizations.indexOf($rootScope.CurrentOrganization.id) > -1;
    };

    $rootScope.hasIdSmartEnabled = () => INSTANCE.isIdSmartEnabled;

    $rootScope.hasBasiqEnabled = () => INSTANCE.isBasiqEnabled;

    $rootScope.hasPpsrEnabled = () => INSTANCE.isPpsrEnabled;

    $rootScope.hasMercuryEnabled = () => INSTANCE.isMercuryEnabled;

    $rootScope.hasMogoPlusEnabled = () => INSTANCE.isMogoPlusEnabled;

    $rootScope.hasCompareClubEnabled = () => INSTANCE.isCompareClubEnabled;

    $rootScope.hasLifeInsuranceDirectEnabled = () => INSTANCE.isLifeInsuranceDirectEnabled;

    $rootScope.hasLoanQEnabled = () => INSTANCE.isLoanQEnabled;

    $rootScope.hasLoanMiniQEnabled = () => INSTANCE.isLoanQEnabled;

    $rootScope.isLearnOrganization = () => {
      const brokerOrganizations = [
        'dd5752f9-97d3-4bc8-89de-134fb750f8f6', // SALESTREKKER DEMO
        '9e44bfdb-e877-4ce3-814e-ab452c406094', // SALESTREKKER PROJECT
        '072cb033-93e0-4872-a5c7-f72cec0a1fe9', // DEMO n CO
        '46699f0c-6a9a-4c2a-81b6-f51ef355eb73', // EVEN
        '8c384592-e8e9-49b1-9dfd-ce6696c38a1f', // LEARN CHF
        '4ebeffeb-f849-40f3-8f8e-e5276edc1914', // LEARN GEM
        'b39197d3-5a04-439c-8a2b-f3adde80200b', // LEARN GNZ
        '1ca41683-b2ce-400f-b2b3-b838dac07f1c', // LEARN IOT
        // LNQ
        '8e5423f3-8ce3-40d0-af2c-f2e703ba55a7', // LEARN MAG
        '4f21f47f-1922-4315-b47f-a6fd6df999bd', // LEARN NLG
        '8992c3c5-b7d2-4da1-b40b-a734978cab52', // LEARN PPC
        '23f21757-313f-450a-aa95-c893435504de', // LEARN PTF
        '578efd69-5151-4c8c-b8b0-f7d7f2c28b28', // LEARN REF
        '6e5ab16c-cd8e-479d-997d-6bae88589e94', // LEARN RMY
        '669e36e3-ddfe-42e5-8c2f-0e6dba92db6b', // LEARN SFG
        '61a30af8-9f70-4748-b7a1-3ee33644ea26', // LEARN VOW
        'ce30de64-2cb3-42fd-a793-03fdedc2006c' // LEARN YNT
      ];

      return brokerOrganizations.indexOf($rootScope.CurrentOrganization.id) > -1;
    };

    $rootScope.IsMedia = $mdMedia;
    const enterpriseOrganizations = [
      '9e44bfdb-e877-4ce3-814e-ab452c406094', // SALESTREKKER PROJECT
      '072cb033-93e0-4872-a5c7-f72cec0a1fe9', // DEMO n CO
      '46699f0c-6a9a-4c2a-81b6-f51ef355eb73', // EVEN
      'cb2dd79e-831f-4c89-a5a6-2d472eb6f276', // LOAN TRACKER
      '41773ab7-136a-4b79-af05-1ff659abbb36', // BONGIORNO
      '6fa626fd-946b-4092-9c85-2b611323ee13', // GAIN FINANCIAL
      '87a33ebb-20ff-4265-b788-5471092333c7', // PROSPER ENTERPRISE
      '99d6f5ff-f390-4918-87f8-2f600d477a45', // WHITESTAR FINANCE
      '324b04bf-023f-44a9-ad9e-fbc7437973d9', // PEBBLE FINANCE ENTERPRISE
      '894a1de9-1f6c-40d8-9520-daf01b024af0' // ST ENTERPRISE
      // .update({ timeStamp: '4670438400' })
    ];
    $rootScope.IsEnterpriseApp = () => {
      if ($rootScope.CurrentOrganization && $rootScope.CurrentOrganization.id) {
        return (
          enterpriseOrganizations.indexOf($rootScope.CurrentOrganization.id) > -1 ||
          enterpriseOrganizations.indexOf($rootScope.CurrentOrganization.idParent) > -1 ||
          enterpriseOrganizations.indexOf($rootScope.CurrentOrganization.idRoot) > -1
        );
      }
      return false;
    };
    $rootScope.IsEnterprise = INSTANCE.isEnterprise || $rootScope.IsEnterpriseApp();
    angular.element('.spinner').css({ display: 'none' });
  });
